import { ReportProfileAlertResourcesBaseModel } from '../../../report-profile-alert-resources-base-model';
import { SharePointGraphGroupModel } from '../../../microsoft/sharepoint/share-point-graph-group-model';

export class SharePointReportProfileAlertVisibilityModel extends ReportProfileAlertResourcesBaseModel {
  group: SharePointGraphGroupModel;
}
